import { post, postJson } from '@/utils/request';

// #region ******** 文件管理 ********
// 列表
export const getAppFileList = params => {
  return post(`/app/getAppFileList`, params);
};
// 详情
export const getAppFile = params => {
  return post(`/app/getAppFile`, params);
};
// 详情byFileNo
export const getAppFileByFileNo = params => {
  return post(`/app/getAppFileByFileNo`, params);
};
// 新增/编辑
export const editAppFile = params => {
  return postJson(`/app/editAppFile`, params);
};
// 删除
export const deleteAppFile = params => {
  return post(`/app/deleteAppFile`, params);
};
// #endregion **** 文件管理 ********

// #region ******** 证书档案 ********
// 列表
export const getUserCertList = params => {
  return post(`/app/getUserCertList`, params);
};
// 列表
export const getUserCert = params => {
  return post(`/app/getUserCert`, params);
};
// 新增/编辑
export const editUserCert = params => {
  return post(`/app/editUserCert`, params);
};
// 删除
export const deleteUserCert = params => {
  return post(`/app/deleteUserCert`, params);
};
// #endregion **** 证书档案 ********
